import { Box } from '@mui/material'
import { AnyPlaybookType, PlaybookType, VideoOverlayDataType } from 'app/types'
import { usePlaybookAuth, useQuery } from 'hooks'
import PageNotFound from 'pages/PageNotFound'
import { ReactElement } from 'react'
import { VideoLoadingSkeleton } from './VideoLoadingSkeleton'

type Props<T extends AnyPlaybookType> = {
    id: string
    children: (_data: { playbook: T; data: VideoOverlayDataType; videos?: Array<PlaybookType> }) => ReactElement
    onSuccessPlaybookFetch?: (_playbook: T) => void
}

export const PlaybookProvider = <T extends AnyPlaybookType>({ id, children, onSuccessPlaybookFetch }: Props<T>) => {
    const { data, isValidating, error } = useQuery<{
        playbook: T
        data: VideoOverlayDataType
        videos?: Array<PlaybookType>
    }>(
        `/c/v1/quickguidde?id=${id}&forEmbed=true`,
        {
            method: 'GET',
        },
        {
            ...usePlaybookAuth(),
            onSuccess: data => {
                onSuccessPlaybookFetch?.(data.playbook)
            },
        },
    )

    const queryParams = new URLSearchParams(location.search)
    const isDarkMode = queryParams.get('dark')

    if (isValidating && isDarkMode) {
        return (
            <Box
                sx={{
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'black',
                }}
            />
        )
    }

    if (isValidating && !data) {
        return <VideoLoadingSkeleton />
    }

    if (error?.message || !data) {
        return <PageNotFound playbookId={id} />
    }

    return children({ playbook: data.playbook, data: data.data, videos: data.videos })
}
